import OurImpact, { OurImpactProps } from "./OurImpact";

export { OurImpact, OurImpactProps };

export default OurImpact;
